import { generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/materialMaster';
import { callApiV3Get, callSettingsApiGet} from 'utilities/apiCaller';
import API from 'constants/api';

export const getMaterialMaster = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_MATERIAL_DATA.PENDING });
        try {
            const res = await mapMaterialDto();
            dispatch({ type: TYPES.FETCH_MATERIAL_DATA.FULFILLED, materialMasterList: res });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_MATERIAL_DATA.REJECTED, errors });
        }
    }
};
export const fetchCustomerMaster = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_CUSTOMER_DATA.PENDING });
        try {
            const res = await callApiV3Get(API.CostRevenue.GetCustomerMaster);
            dispatch({ type: TYPES.FETCH_CUSTOMER_DATA.FULFILLED, customerMasterList: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_CUSTOMER_DATA.REJECTED, errors });
        }
    }
};

interface IMaterial {
	readonly id: number;
	readonly materialNo: number;
    readonly name: string;
    readonly description: string;
    readonly defaultUoM: string;
    readonly category: string;
    readonly subcategory: string;
}

interface ISettingsMaterial {
	readonly identifier: number;
	readonly materialNumber: number;
	readonly materialName: string;
	readonly materialDescription: string;
	readonly defaultUoM: string;
	readonly materialCategory: string;
	readonly materialSubcategory: string;
}

async function mapMaterialDto() {
    const page = 1;
    const limit = 1000;

    const results = await callSettingsApiGet(`${API.FinanceConfig.Materials}`, {page, limit});

    return results.data.data
        .map((material: ISettingsMaterial) => <IMaterial>{
            id: material.identifier,
            materialNo: material.materialNumber,
            name: material.materialName,
            description: material.materialDescription,
            defaultUoM: material.defaultUoM,
            category: material.materialCategory,
            subcategory: material.materialSubcategory
        })
        .sort((a: IMaterial, b: IMaterial) => {
            if (a.id < b.id) {
                return -1;
            } 
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        })
}